.name{color:#e1f0f0}.link{color:#e1f0f0;margin-top:5px}.clinician-portfolio-container{text-align:center;height:3em}
/*# sourceMappingURL=clinician-portfolio.component-2DHG2TLE.css.map */
